import React from 'react';
import PropTypes from 'prop-types';
import GDABadge from '../../svg/icons/gda_badge.svg';

import './NotifyBannerAnnouncement.scss';
import GdaBanner from '../GdaBanner/GdaBanner';
import useExperiment from '../Experiments/useExperiment';
import { ALL_HIDE_POST_NOTIFY_ANNOUNCEMENTS } from '../../constants/optimizelyExperiments';

const NotifyBannerAnnouncement = ({
  announcement, onClick,
}) => {
  const [isFFEnabled] = useExperiment(ALL_HIDE_POST_NOTIFY_ANNOUNCEMENTS);

  const showBanner = isFFEnabled ? announcement : true;
  return showBanner ? (
    <div className="NotifyBannerAnnouncement">
      <GdaBanner
        icon={GDABadge}
        gdaIconWidth="50px"
        gdaIconHeight="50px"
        bannerText="Be one of the first in line with Priority Notify"
        translationKey="gda_priority_notify_banner_text"
        onClick={onClick}
      />
    </div>
  ) : null;
};
NotifyBannerAnnouncement.propTypes = {
  announcement: PropTypes.shape({
    id: PropTypes.number,
  }),
  onClick: PropTypes.func.isRequired,
};

NotifyBannerAnnouncement.defaultProps = {
  announcement: undefined,
};

export default NotifyBannerAnnouncement;
